import { render, staticRenderFns } from "./faceRule.vue?vue&type=template&id=6644cf39&scoped=true"
import script from "./faceRule.vue?vue&type=script&lang=js"
export * from "./faceRule.vue?vue&type=script&lang=js"
import style0 from "./faceRule.vue?vue&type=style&index=0&id=6644cf39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6644cf39",
  null
  
)

export default component.exports